import { getMutableComponentProps } from "./utils";
const PACING_EXCLUDED_SELECT_VALUES = ["Currency", "Fund", "FundManager", "VintageYear"];
export const filterFundLevelAxesForPacing = (componentProps, allDependencies, originalComponentProps) => {
    const pacingObjective = allDependencies.pacingPlanObjective;
    if (!pacingObjective || pacingObjective === "none") {
        return componentProps;
    }
    const mutableComponentProps = getMutableComponentProps(componentProps, originalComponentProps);
    if (mutableComponentProps.dataSelectProps) {
        for (const dataSelectProp of mutableComponentProps.dataSelectProps) {
            if (dataSelectProp.selectValues) {
                for (const key of PACING_EXCLUDED_SELECT_VALUES) {
                    delete dataSelectProp.selectValues[key];
                }
            }
        }
    }
    return mutableComponentProps;
};
